import Emitter from "es6-event-emitter";
import { generateCoverURL, labelToDate } from "./../utilities/utils";

export default class HorsseriesStore extends Emitter {
  additionalDownloadTokens = null;
  packages = [];

  _apiManager = null;

  _imageSizes = null;

  constructor(
    apiManager,
    additionalDownloadTokens,
    imageSizes,
    options,
    locale,
    dateFormat
  ) {
    super();
    this._apiManager = apiManager;
    this.additionalDownloadTokens = additionalDownloadTokens;
    this._imageSizes = imageSizes;
    this._options = options;
    this._dateFormat = dateFormat;
    this._locale = locale;
  }

  async loadHorsseries() {
    // load Horsseries for all tokens + sort by date
    let promiseArray = [];
    this.additionalDownloadTokens.forEach((token) => {
      promiseArray.push(this._apiManager.getContentPackageList(token.Value));
    });

    try {
      const results = await Promise.all(promiseArray);
      results.forEach((result) => {
        result.forEach((hsPub) => {
          if (
            !this.packages.find(
              (packageEl) =>
                packageEl.ContentPackageId === hsPub.ContentPackageId
            )
          )
            this.packages.push(this.normalizePubForSwiper(hsPub));
        });
      });

      this.packages.sort((a, b) => {
        if (a.ContentPackagePublishTime === b.ContentPackagePublishTime) {
          return a.ContentPackageName > b.ContentPackageName ? 1 : -1;
        }
        return a.ContentPackagePublishTime < b.ContentPackagePublishTime
          ? 1
          : -1;
      });
    } catch (err) {
      //TODO error handling here?
    }
    //FIXME Touch reader depends on this event
    this.trigger("horsseries:loaded");
  }

  getHorsseries() {
    return this.packages;
  }

  normalizePubForSwiper(pub) {
    if (pub.ContentPackageFormat === "Extra") {
      return null;
    }
    const result = pub;

    if (this._options.useHSNameAsLabel) {
      result.label = pub.ContentPackageName;
    } else {
      result.label = this.beautifyDate(pub.PublicationDate);
    }

    result.imageUrl = generateCoverURL(
      pub.ContentPackageId,
      this._imageSizes.S,
      pub.ThumbnailId,
      pub.Version
    );

    return result;
  }

  beautifyDate(uglyDate) {
    return labelToDate(uglyDate, this._locale, this._dateFormat);
  }

  /**
   * Returns content package price based on content package id
   * @param  {Integer} cpId content package id
   * @return {Float}        contant package price
   */
  getContentPackagePrice(cpId) {
    const contentPackage = this.packages.find((cp) => {
      return cp.ContentPackageId == cpId; // eslint-disable-line
    });

    if (contentPackage) {
      if (contentPackage.StoreProducts[0]) {
        return contentPackage.StoreProducts[0].Price;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/stores/horsseriesStore.js